export default __webpack_public_path__ + "static/media/munir.791cfdd9.png";